import React from 'react';
import PropTypes from 'prop-types';
import LaneContainer from '../UI/LaneContainer';
import { useTitle } from './containers/TitleDataStore';
import { Icon } from 'antd';
import handlePlural from '../../util/handlePlural';
import CommunityButton from '../UI/CommunityButton';
import useNominationTargets from '../Reviews/ReviewEditor/data/useNominationTargets';
import NominationsEditorAnchor from '../Reviews/ReviewEditor/NominationsEditorAnchor';

TitleYourNominations.propTypes = {
	sku: PropTypes.string,
	showSmallJacket: PropTypes.bool,
	isMobile: PropTypes.bool,
};

export default function TitleYourNominations({
	sku,
	showSmallJacket,
	isMobile,
}) {
	const titleDataStore = useTitle();
	const nominationTargets = useNominationTargets(sku);
	const options = nominationTargets.getOptions();
	const optionsCount = options.length;

	const { isReviewDataLoading, isProductDataLoading } = titleDataStore.state;

	const renderAnchor = () => {
		const options = nominationTargets.getOptions();
		const optionsCount = options.length;

		if (optionsCount === 0) {
			return <div />;
		}

		const submittedCount = nominationTargets.getAlreadySubmittedCount();
		const submittedCountLabel = handlePlural('nomination', submittedCount);

		return (
			<NominationsEditorAnchor
				sku={sku}
				onUpdate={nominationTargets.refresh}>
				<CommunityButton
					text={`${submittedCountLabel}, ${optionsCount} available`}>
					<Icon type="trophy" />
				</CommunityButton>
			</NominationsEditorAnchor>
		);
	};

	const doRenderAnchor = () => {
		return (
			!isProductDataLoading &&
			!isReviewDataLoading &&
			!nominationTargets.isLoading()
		);
	};

	if (optionsCount > 0) {
		return (
			<LaneContainer
				majorHeader="Nominate"
				renderIcon={() => <Icon type="trophy" />}
				extra={
					doRenderAnchor() && !showSmallJacket && !isMobile ? (
						renderAnchor()
					) : (
						<React.Fragment />
					)
				}>
				{doRenderAnchor() && (showSmallJacket || isMobile) ? (
					<div style={{ marginBottom: '10px' }}>{renderAnchor()}</div>
				) : (
					<React.Fragment />
				)}
			</LaneContainer>
		);
	} else {
		return <React.Fragment />;
	}
}
